import { useContext } from 'react';
import { GlobalContext } from '../context';

function useWeb3Provider() {
  const { provider } = useContext(GlobalContext);
  return provider;
}

export default useWeb3Provider;
